import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '../shared/service/form-builder.service';
import { FormElement } from '../shared/model/form-element.model';
import { FormGroup } from '../shared/model/form-group.model';
import { FormTemplate } from '../shared/model/form-template.model';
import { FormField } from '../shared/model/form-field.model';
import { ValueTypeEnum } from '../shared/model/value-type-enum.model';
import { FormElementType } from '../shared/model/form-element-type.model';
import { FormElementTypes } from '../shared/service/form-element-types.service';
import {
  UtilService,
  DialogService,
  NotificationService,
  NameValueInteger,
  NameValueString,
  NameValue,
  NameVal,
  NameValString,
} from '../../shared/index';
import { FormElementTextBox } from '../shared/model/form-element-textbox.model';
import { FormElementCheckBox } from '../shared/model/form-element-checkbox.model';
import { FormElementTextDisplay } from '../shared/model/form-element-text-display.model';
import { FormElementHeader } from '../shared/model/form-element-header.model';
import { FormElementDropDownStringValue } from '../shared/model/form-element-dropdown-string-value.model';
import { FormElementDropDownIntegerValue } from '../shared/model/form-element-dropdown-integer-value.model';
import { FormFields } from '../shared/service/form-fields.service';
import { FormElementDateInput } from '../shared/model/form-element-date-input.model';
import { FormElementIntegerInput } from '../shared/model/form-element-integer-input.model';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { FieldGroupTypeEnum } from '../shared/model/field-group-type-enum.model';
import { FormElementSummary } from '../shared/model/form-element-summary.model';
import { FormBuilderProfileEditElementComponent } from '../form-builder-profile-element/form-builder-profile-edit-element.component';
import { FormBuilderSocialMediaEditElementComponent } from '../form-builder-social-media-element/form-builder-social-media-edit-element.component';
import { FormBuilderListingEditElementComponent } from '../form-builder-listing-element/form-builder-listing-edit-element.component';
import { FormBuilderProfileAddressEditElementComponent } from '../form-builder-profile-address-element/form-builder-profile-address-edit-element.component';
import { FormBuilderHbaProfileDataEditElementComponent } from '../vertical/form-builder-hba-profile-data-element/form-builder-hba-profile-data-edit-element.component';
import { RevenueItemService } from '../../revenue/shared/revenue-items/revenue-item.service';
import { FormBuilderMembershipLevelEditElementComponent } from '../form-builder-membership-level-element/index';
import { FormFieldRevenueInfo } from '../shared/model/revenue/form-field-revenue-info.model';
import { FormBuilderAffiliationChecklistEditElementComponent } from '../form-builder-affiliation-checklist-element/index';
import { FormBuilderFileUploadEditElementComponent } from '../form-builder-upload-file-element/form-builder-upload-file-edit-element.component';
import { FormBuilderEmailOptIntEditElementComponent } from '../form-builder-email-optin-element';

@Component({
  selector: 'wl-form-builder-edit-element',
  templateUrl: 'form-builder-edit-element.component.html',
  providers: [FormBuilder, UtilService, NotificationService, FormElementTypes, FormFields, NavigationService, RevenueItemService],
    standalone: false
})
export class FormBuilderEditElementComponent implements OnInit {
  private _formBuilder: FormBuilder;
  private _utilService: UtilService;
  private _notifyService: NotificationService;
  private _formElementTypeService: FormElementTypes;
  private _dialogService: DialogService;
  private _formFieldsService: FormFields;
  private _revenueItemService: RevenueItemService;

  private _originalFormElement: FormElement;

  public selectedFormElement = { Text: '' } as FormElement;
  public mutuallyExclusiveFormElements: Array<FormElementSummary>;
  public potentialFieldPrice: number;
  public selectedFieldPrice: number;
  public useArc: boolean;
  public fieldGroupTypes: any;
  public fieldCanBeRequired: boolean;
  public showModal = false;
  public htmlText = '';
  @Output() onChanges = new EventEmitter<any>();

  @ViewChild('relatedProfileSettingsElement', { static: false }) _relatedProfileElement: FormBuilderProfileEditElementComponent;
  @ViewChild('relatedOrgSettingsElement', { static: false }) _relatedOrgSettingsElement: FormBuilderProfileEditElementComponent;
  @ViewChild('socialMediaSettingsElement', { static: false }) _socialMediaElement: FormBuilderSocialMediaEditElementComponent;
  @ViewChild('listingSettingsElement', { static: false }) _listingElement: FormBuilderListingEditElementComponent;
  @ViewChild('profileAddressSettingsElement', { static: false }) _profileAddressElement: FormBuilderProfileAddressEditElementComponent;
  @ViewChild('hbaProfileDataSettingsElement', { static: false }) _hbaProfileDataElement: FormBuilderHbaProfileDataEditElementComponent;
  @ViewChild('membershipLevelSettingsElement', { static: false }) _membershipLevelSettingsElement: FormBuilderMembershipLevelEditElementComponent;
  @ViewChild('affiliationCodeSettingsElement', { static: false }) _affiliationCodeSettingsElement: FormBuilderAffiliationChecklistEditElementComponent;
  @ViewChild('fileUploadSettingsElement', { static: false }) _fileUploadSettingsElement: FormBuilderFileUploadEditElementComponent;
  @ViewChild('emailOptInSettingsElement', { static: false }) _emailOptInSettingsElement: FormBuilderEmailOptIntEditElementComponent;

  public constructor(
    formBuilder: FormBuilder,
    utilService: UtilService,
    notifyService: NotificationService,
    formElementTypeService: FormElementTypes,
    dialogService: DialogService,
    formFieldsService: FormFields,
    navigationService: NavigationService,
    revenueItemService: RevenueItemService
  ) {
    this.fieldGroupTypes = FieldGroupTypeEnum;
    this._formBuilder = formBuilder;
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._formElementTypeService = formElementTypeService;
    this._dialogService = dialogService;
    this._formFieldsService = formFieldsService;
    this._originalFormElement = new FormElement();
    this.selectedFormElement = new FormElement();
    this.mutuallyExclusiveFormElements = new Array<FormElementSummary>();
    this.potentialFieldPrice = null;
    this.selectedFieldPrice = null;
    this._revenueItemService = revenueItemService;
    this.useArc = false;
    this.fieldCanBeRequired = false;
  }
  ngOnInit(): void {}

  modelChange(data: any) {}

  public open(formElement: any) {
    this.selectedFormElement = formElement;
    this.useArc = false;

    if (formElement.ElementTypeId == 10) {
      this._socialMediaElement.socialMediaSettings = formElement;
      this._socialMediaElement.refetchSocialMedia();
      // set form element equal so we can cancel safely
      formElement = this._socialMediaElement;
    }

    if (formElement.ElementTypeId == 7) {
      this.htmlText = this.selectedFormElement.Text;
    }

    this._originalFormElement = this._utilService.clone(formElement);

    this.showModal = true;

    if (formElement.ElementTypeId == 9) {
      this._relatedProfileElement.relatedProfileSettings = formElement;
    }

    if (formElement.ElementTypeId == 19) {
      this._relatedOrgSettingsElement.relatedProfileSettings = formElement;
    }

    if (formElement.ElementTypeId == 11) {
      this._listingElement.listingSettings = formElement;
    }

    if (formElement.ElementTypeId == 13) {
      this._profileAddressElement.profileAddressSettings = formElement;
    }

    if (formElement.ElementTypeId == 14) {
      this._hbaProfileDataElement.hbaProfileDataSettings = formElement;
    }

    if (formElement.ElementTypeId == 16) {
      this._membershipLevelSettingsElement.membershipLevelSettings = formElement;
      this._membershipLevelSettingsElement.refetchMembershipLevels();
    }

    if (formElement.ElementTypeId == 17) {
      this._affiliationCodeSettingsElement.affCodeSettings = formElement;
      this._affiliationCodeSettingsElement.refetchAffCodes();
    }

    if (formElement.ElementTypeId == 18) {
      this._fileUploadSettingsElement.fileUploadSettings = formElement;
    }

    if (formElement.ElementTypeId == 20) {
      this._emailOptInSettingsElement.emailOptInData = formElement;
    }

    // revenue item price
    if (formElement.Field && formElement.Field.FieldType == 85 && formElement.Field.FieldValue > 0) {
      if (!formElement.Field.RevenueInfo || !formElement.Field.RevenueInfo.length) {
        this._revenueItemService.getRevenueItem(formElement.Field.FieldValue).then((data) => {
          let price = data.UnitPrice;
          if (price <= 0) {
            price = data.BasePrice;
          }
          this.potentialFieldPrice = price;
        });
      } else if (formElement.Field.RevenueInfo[0].UseArc) {
        this.useArc = true;
      } else {
        this.selectedFieldPrice = formElement.Field.RevenueInfo[0].Price;
      }
    }

    this.fieldCanBeRequired = this.canBeRequired(this.selectedFormElement.Field.DisplayValueType);
  }

  public close() {
    this.selectedFormElement.EditMode = false;

    if (this.htmlText) {
      this.selectedFormElement.Text = this.htmlText;
    }

    // set the revenue item price
    if (this.selectedFieldPrice != null && this.selectedFieldPrice > 0) {
      let revInfos = new Array<FormFieldRevenueInfo>();
      let revInfo = new FormFieldRevenueInfo();
      revInfo.Price = this.selectedFieldPrice;
      revInfo.RevenueItemNum = this.selectedFormElement.Field.FieldValue;
      let revInfoArray = this.selectedFormElement.Field.RevenueInfo;
      if (revInfoArray && revInfoArray.length > 0) {
        let existingRevInfo = revInfoArray[0];
        revInfo.ProrationMonth = existingRevInfo.ProrationMonth;
        revInfo.IsProrated = existingRevInfo.IsProrated;
      }
      revInfos.push(revInfo);
      this.selectedFormElement.Field.RevenueInfo = revInfos;
    } else if (this.selectedFieldPrice == null || this.selectedFieldPrice == 0) {
      if (this.selectedFormElement.Field.RevenueInfo != null && !this.selectedFormElement.Field.RevenueInfo.some((x) => x.UseArc)) {
        this.selectedFormElement.Field.RevenueInfo = null;
      }
    }
    this.emitOutputObject();
    this.selectedFieldPrice = null;
    this.potentialFieldPrice = null;
    this.htmlText = null;
    this.showModal = false;
  }

  public cancel = (): void => {
    this.selectedFormElement.EditMode = false;
    this._utilService.mapSafe(this._originalFormElement, this.selectedFormElement);
    this.emitOutputObject();
    this.selectedFieldPrice = null;
    this.potentialFieldPrice = null;
    this.htmlText = null;
    this.showModal = false;
  };

  emitOutputObject = (): void => {
    this.onChanges.emit(this.selectedFormElement);
  };

  public getFormFieldGroupName = (value: FieldGroupTypeEnum): string => {
    return this._formFieldsService.getFieldGroupTypeEnumName(value);
  };

  public onIsMutuallyExclusiveChanged = (): void => {
    if (this._utilService.isNotNullOrUndefined(this.selectedFormElement.Field)) {
      if (this.selectedFormElement.Field.DisplayValueType == 5) {
        if (this.selectedFormElement['IsMutuallyExclusive'] == false) {
          //clear out all selected values
          for (let el of this.selectedFormElement['MutuallyExclusiveFormElements']) {
            el.Selected = false;
          }
        }
      }
    }
  };

  public canBeRequired = (fieldValueType: number): boolean => {
    return [
      ValueTypeEnum.string,
      ValueTypeEnum.int,
      ValueTypeEnum.decimal,
      ValueTypeEnum.date,
      ValueTypeEnum.boolean,
      ValueTypeEnum.StringDropDown,
      ValueTypeEnum.State,
      ValueTypeEnum.AffiliationChecklist,
    ].some((x) => x == fieldValueType);
  };
}
